import l, { forwardRef as c } from "react";
import a from "./index.es437.js";
function s() {
  return s = Object.assign || function(r) {
    for (var o = 1; o < arguments.length; o++) {
      var t = arguments[o];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (r[e] = t[e]);
    }
    return r;
  }, s.apply(this, arguments);
}
function p(r, o) {
  if (r == null) return {};
  var t = y(r, o), e, n;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(r);
    for (n = 0; n < i.length; n++)
      e = i[n], !(o.indexOf(e) >= 0) && Object.prototype.propertyIsEnumerable.call(r, e) && (t[e] = r[e]);
  }
  return t;
}
function y(r, o) {
  if (r == null) return {};
  var t = {}, e = Object.keys(r), n, i;
  for (i = 0; i < e.length; i++)
    n = e[i], !(o.indexOf(n) >= 0) && (t[n] = r[n]);
  return t;
}
var u = c(function(r, o) {
  var t = r.color, e = t === void 0 ? "currentColor" : t, n = r.size, i = n === void 0 ? 24 : n, f = p(r, ["color", "size"]);
  return /* @__PURE__ */ l.createElement("svg", s({
    ref: o,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: e,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, f), /* @__PURE__ */ l.createElement("line", {
    x1: "18",
    y1: "20",
    x2: "18",
    y2: "10"
  }), /* @__PURE__ */ l.createElement("line", {
    x1: "12",
    y1: "20",
    x2: "12",
    y2: "4"
  }), /* @__PURE__ */ l.createElement("line", {
    x1: "6",
    y1: "20",
    x2: "6",
    y2: "14"
  }));
});
u.propTypes = {
  color: a.string,
  size: a.oneOfType([a.string, a.number])
};
u.displayName = "BarChart2";
export {
  u as default
};
//# sourceMappingURL=index.es367.js.map
